
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.521","height":"17.111"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 972","fill":"none","stroke":"#9b9b9b"}},[_c('path',{attrs:{"data-name":"Line 62","stroke-linecap":"round","d":"M.5.885V16.15"}}),_c('g',{attrs:{"data-name":"Group 973"}},[_c('path',{attrs:{"data-name":"Line 63","d":"M.271 4.279h3.753"}}),_c('path',{attrs:{"data-name":"Line 64","d":"M.271 12.93h3.753"}})])]),_c('g',{attrs:{"data-name":"Ellipse 199","transform":"translate(2.552)","fill":"none","stroke":"#9b9b9b"}},[_c('ellipse',{attrs:{"cx":"8.484","cy":"8.556","rx":"8.484","ry":"8.556","stroke":"none"}}),_c('ellipse',{attrs:{"cx":"8.484","cy":"8.556","rx":"7.984","ry":"8.056"}})]),_c('path',{attrs:{"data-name":"Path 1448","d":"M9.595 12.855a.982.982 0 00.336.058h1.675a.98.98 0 00.338-.058 4.225 4.225 0 001.72-1.23l.305-.143a11.567 11.567 0 011.754-.679 2.4 2.4 0 001.836-2.3 2.537 2.537 0 00-1.075-1.929 2.378 2.378 0 00-1.241-.471 8.159 8.159 0 00-.079-.628.527.527 0 00-.508-.455H6.887a.527.527 0 00-.508.456 8.523 8.523 0 00-.113 1.3c-.036 2.854 1.329 5.36 3.329 6.079zm2.062-.787a.15.15 0 01-.05.007H9.931a.147.147 0 01-.05-.007C8.467 11.554 7.43 9.905 7.168 7.88h7.208c-.265 2.018-1.309 3.672-2.719 4.188zm5.067-3.565a1.559 1.559 0 01-1.229 1.493c-.319.091-.643.2-.986.338a7.911 7.911 0 00.769-3.388 1.6 1.6 0 01.711.3 1.731 1.731 0 01.734 1.255zM7.17 5.857h7.206a7.729 7.729 0 01.066 1.012v.174H7.108v-.262a7.715 7.715 0 01.066-.924z","fill":"#9b9b9b"}})])
          )
        }
      }
    